import type { SettingsNavEntry } from "@mbits/mray-react-common";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";

// Drives the side-nav sub-menu under "Settings". The backend's list order is
// not used, so the menu stays stable across API response changes.
export const SETTINGS_NAV: SettingsNavEntry[] = [
  {
    key: "delete_policy",
    labelKey: "settingsPage.nav.deletePolicy",
    icon: AccessTimeOutlinedIcon,
  },
  {
    key: "mandatory_tags",
    labelKey: "settingsPage.nav.mandatoryTags",
    icon: RuleOutlinedIcon,
  },
  {
    key: "allowed_tags",
    labelKey: "settingsPage.nav.allowedTags",
    icon: LabelOutlinedIcon,
  },
  {
    key: "require_workitem",
    labelKey: "settingsPage.nav.requireWorkitem",
    icon: AssignmentTurnedInOutlinedIcon,
  },
  {
    key: "tag_modifiers",
    labelKey: "settingsPage.nav.tagModifiers",
    icon: SellOutlinedIcon,
  },
  {
    key: "legal",
    labelKey: "settingsPage.nav.legal",
    icon: GavelOutlinedIcon,
    settingKeys: ["terms_of_service", "privacy_policy"],
  },
];

// Sub-setting the bare /settings route redirects to.
export const DEFAULT_SETTING_KEY = SETTINGS_NAV[0].key;
